import { Control, FilterType } from '../../../../types/types';
import { InputType } from '../../../Input/Input';

export const getInputType = (
  type: FilterType,
  control?: Control
): InputType => {
  if (type === 'integer' || type === 'float') {
    return 'number';
  }

  if (control?.type === 'string' && control?.password) {
    return 'password';
  }

  return 'text';
};
